import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import Collapse from '@mui/material/Collapse';
import ListItemText from '@mui/material/ListItemText';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import IconButton from '@mui/material/IconButton';
import PersonIcon from '@mui/icons-material/Person';
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import PractitionerInfoHeaderMobile from './PractitionerInfoHeaderMobile';

const MobileAccountMenu = ({ profileItems, hasDefaultLocation }) => {
	const { palette } = useTheme();
	const [drawerOpen, setDrawerOpen] = useState(false);

	const renderMenuItem = menuItem => (
		<ListItemButton
			key={menuItem.key}
			{...(menuItem.isLegacy
				? {
						component: Link,
						href: menuItem.path,
						target: '_self',
						rel: 'noreferrer',
					}
				: {
						component: RouterLink,
						to: menuItem.path,
						onClick: () => setDrawerOpen(false),
					})}
			sx={{
				color: palette.text.primary,
				pl: 4,
			}}
		>
			<ListItemText primary={menuItem.label} />
		</ListItemButton>
	);
	return (
		<>
			<IconButton
				aria-label='Mobile account menu'
				aria-haspopup='dialog'
				data-testid='mobile-profile-menu'
				onClick={() => setDrawerOpen(true)}
			>
				{/* TODO: swtich to theme color when using eve theme */}
				<PersonIcon sx={{ color: 'white' }} />
			</IconButton>
			<Drawer
				onClose={() => setDrawerOpen(false)}
				open={drawerOpen}
				role='navigation'
				PaperProps={{ sx: { width: '66%' } }}
			>
				<List component='div'>
					{hasDefaultLocation && (
						<ListItemButton selected>
							<ListItemText primary='My Account' />
							<KeyboardArrowRightIcon />
						</ListItemButton>
					)}

					<Collapse in timeout='auto' unmountOnExit>
						<List component='div'>
							{profileItems.map(menuItem => {
								if (
									!hasDefaultLocation &&
									menuItem?.key === 'log-out'
								) {
									return renderMenuItem(menuItem);
								}

								if (hasDefaultLocation) {
									return renderMenuItem(menuItem);
								}
								return null;
							})}
						</List>
					</Collapse>
				</List>
				<Divider />
				<PractitionerInfoHeaderMobile />
			</Drawer>
		</>
	);
};

MobileAccountMenu.propTypes = {
	profileItems: PropTypes.array.isRequired,
	hasDefaultLocation: PropTypes.bool.isRequired,
};

export default MobileAccountMenu;
